import { use } from 'react';

import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { ConfigContext } from 'Context/config';

import { TRUSTPILOT_URL } from 'Utilities/urls';

import { ReactComponent as TpStars } from '../../../../../client/assets_seller/trustpilot/trustpilot-stars-4.5-2022.svg';
import { TrustpilotData } from '../trustpilotCommon/Trustpilot.types';
import LocalTexts from '../trustpilotCommon/TrustpilotTexts.json';

import styles from './TrustpilotFooter.scss';

const LocalT = new MDText(LocalTexts);

export const TrustpilotFooterContent = ({ tpData }: { tpData?: TrustpilotData }) => {
  if (!tpData || tpData?.rating === '0') {
    return null;
  }

  return (
    <footer className={styles.ratingInfo}>
      <div className={styles.set1}>
        <div>
          {LocalT.translate('rated')}
          {' '}
          <strong>{tpData.rating}</strong>
          {' '}
          {LocalT.translate('outOf')}
          {' '}
          <strong>5</strong>
        </div>
        {' '}
        <TpStars aria-label='Trustpilot star rating' height='24' role='img' width='128' />
        {' '}
      </div>
      <Hyperlink
        inherit
        as="a"
        href={`${TRUSTPILOT_URL}?utm_medium=trustbox&utm_source=Slider`}
        label={`${tpData.totalReviews} ${LocalT.translate('reviews')}`}
        rel="noreferrer"
        target="_blank"
      />
    </footer>
  );
};

export const TrustpilotFooter = () => {
  const { configState: { reviewsData } } = use(ConfigContext);

  const tpData = reviewsData ? {
    rating: reviewsData.rating,
    totalReviews: (Math.floor(parseInt(reviewsData.totalReviews) / 250) * 250).toLocaleString(),
  } : undefined;

  return <TrustpilotFooterContent tpData={tpData} />;
};
